/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
// eslint-disable-next-line no-restricted-imports
import { IconName } from 'common/components/controls/icon';
// eslint-disable-next-line no-restricted-imports
import Backbone from 'common/vendor/backbone';
// eslint-disable-next-line no-restricted-imports
import { ChannelSwitcherPopoverId } from 'components/popovers/popover-ids';
// eslint-disable-next-line no-restricted-imports
import { showPopover, State } from 'modules';
import React, { lazy, Suspense } from 'react';
import { connect, Dispatch } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { getMe, isPopoverShown } from 'selectors';

// eslint-disable-next-line no-restricted-imports
import { MemberModel } from 'types';
import HeaderButton from './button';

const ChannelSwitcherPopoverPromise = import(/* webpackChunkName: "gamma-channel-switcher-popover" */ 'components/popovers/channel-switcher');
const ChannelSwitcherPopover = lazy(() => ChannelSwitcherPopoverPromise);

interface ChannelSwitcherButtonProps {
  member: MemberModel | undefined;
  hostname: string;
  isActive: boolean;
  onClick: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
}

// Show channel picker if user is allowed to view multiple channels
// OR if we're not on production (to make development easier)
const shouldShowChannelPicker = (
  member: MemberModel | undefined,
  hostname: string,
): boolean => {
  if (hostname !== 'trello.com') {
    return true;
  }

  return !!(member && member.channels && member.channels.allowed.length > 1);
};

export class ChannelSwitcherButton extends React.Component<
  ChannelSwitcherButtonProps
> {
  channelSwitcherButtonRef = React.createRef<HTMLButtonElement>();

  render() {
    const { member, hostname, isActive, onClick } = this.props;
    const showButton = shouldShowChannelPicker(member, hostname);
    if (!showButton) {
      return null;
    }

    return (
      <>
        <HeaderButton
          icon={IconName.Gear}
          onClick={onClick}
          ref={this.channelSwitcherButtonRef}
          testId={HeaderTestIds.ChannelPickerButton}
        />
        {member &&
          showButton &&
          isActive && (
            <Suspense fallback={null}>
              <ChannelSwitcherPopover
                target={() => this.channelSwitcherButtonRef.current}
              />
            </Suspense>
          )}
      </>
    );
  }
}

const mapStateToProps = (state: State) => {
  return {
    member: getMe(state),
    isActive: isPopoverShown(state, ChannelSwitcherPopoverId),
    hostname: Backbone.history.location.hostname,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<object>) => {
  return {
    onClick(e: React.MouseEvent<HTMLElement>) {
      dispatch(showPopover({ name: ChannelSwitcherPopoverId }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChannelSwitcherButton);



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/channel-switcher-button.tsx